import React, { Component } from "react";
import axios from "axios";

import constants from "./constants";
import NewsGrid from "./components/newsGrid";
import Popup from "./components/popup";
import PreferencesPane from "./components/preferencesPane";
import SettingsPane from "./components/settingsPane";
import Sidebar from "./components/sidebar";
import "./App.css";

class App extends Component {
  constructor(props) {
    super(props);

    // Initialize settings
    if (localStorage.getItem(constants.settings[0].key) === null) {
      constants.settings.forEach((setting) =>
        localStorage.setItem(setting.key, setting.defaultValue)
      );
    }

    this.state = {
      articles: [],
      popupActive: 0,
      popupHidden: true,
      settings: Object.fromEntries(
        constants.settings.map((setting) => [
          setting.key,
          localStorage.getItem(setting.key),
        ])
      ),
    };

    this.onClosePopup = this.onClosePopup.bind(this);
    this.onDisplayPopup = this.onDisplayPopup.bind(this);
    this.updateArticles = this.updateArticles.bind(this);
  }

  componentDidMount() {
    this.updateArticles();
  }

  onClosePopup() {
    if (this.state.popupActive === constants.popup.settings) {
      this.setState({
        settings: Object.fromEntries(
          constants.settings.map((setting) => [
            setting.key,
            localStorage.getItem(setting.key),
          ])
        ),
      });

      // I only write bad code before a demo :')
      setTimeout(this.updateArticles, 250);
    }

    this.setState({
      popupActive: 0,
    });

    setTimeout(() => {
      this.setState({
        popupHidden: true,
      });
    }, 250);
  }

  onDisplayPopup(popup, data) {
    this.setState({
      popupActive: popup,
      popupHidden: false,
    });
  }

  updateArticles() {
    axios
      .get(constants.backend_url, {
        params: this.state.settings,
      })
      .then((res) => {
        this.setState({
          articles: res.data,
        });
      });
  }

  render() {
    return (
      <div className="App">
        <Popup
          active={this.state.popupActive !== 0}
          hidden={this.state.popupHidden}
          onClosePopup={this.onClosePopup}
          onDisplayPopup={this.onDisplayPopup}
        >
          {(() => {
            if (this.state.popupActive === constants.popup.preferences) {
              return <PreferencesPane />;
            } else if (this.state.popupActive === constants.popup.settings) {
              return <SettingsPane />;
            }
          })()}
        </Popup>
        <Sidebar onDisplayPopup={this.onDisplayPopup} />
        <NewsGrid
          articles={this.state.articles}
          onDisplayPopup={this.onDisplayPopup}
        />
      </div>
    );
  }
}

export default App;
